/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespPriceTiles_searchBrowse = {|
  +priceTiles: ?$ReadOnlyArray<?{|
    +displayName: ?string;
    +image: ?string;
    +url: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespPriceTiles_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPriceTile_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeOnApprovalPromoTile_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade",
          "type": "Boolean"
        }
      ],
      "concreteType": "SearchBrowsePriceTile",
      "name": "priceTiles",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "displayName",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "image",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
